import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";

export default function Hero() {
  const scrollToWaitlist = () => {
    document.getElementById("waitlist-section")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="relative min-h-[100svh] flex items-end sm:items-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* cinematic wedding photograph */}
      <img
        src="/trust-bg.webp"
        alt="Sposi sereni nella location delle nozze che organizzano tutto da un tablet con iuni"
        className="absolute inset-0 w-full h-full object-cover object-center"
        data-testid="hero-image"
      />
      {/* readability scrims: from bottom on mobile, from the left on desktop; gentle fade into the next section */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/40 to-black/15 sm:bg-gradient-to-r sm:from-black/65 sm:via-black/40 sm:to-black/10" />
      <div className="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-[#FBFBFB] to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full pt-28 pb-40 sm:pb-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-xl"
        >
          <span
            data-testid="hero-eyebrow-badge"
            className="inline-block text-[11px] font-bold uppercase tracking-[0.18em] text-white bg-white/15 backdrop-blur-md border border-white/20 px-4 py-2 rounded-full"
          >
            Lancio in anteprima • Solo 50 coppie
          </span>
          <h1
            data-testid="hero-title"
            className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.12] text-white mt-6 [text-shadow:0_2px_30px_rgba(0,0,0,0.35)]"
          >
            Sposarsi,{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#F2B39B] to-[#E2856E]">
              senza rimandare.
            </span>
          </h1>
          <p
            data-testid="hero-subtitle"
            className="text-base sm:text-lg text-white/85 leading-relaxed mt-6 [text-shadow:0_1px_16px_rgba(0,0,0,0.3)]"
          >
            La piattaforma all-in-one per organizzare e finanziare il tuo matrimonio
          </p>
          <div className="mt-9">
            <button
              data-testid="hero-waitlist-cta"
              onClick={scrollToWaitlist}
              className="inline-flex items-center gap-2.5 px-8 py-4 text-base font-semibold text-white rounded-2xl bg-gradient-to-r from-[#E07A5F] to-[#E2856E] shadow-[0_8px_28px_rgba(224,122,95,0.45)] hover:shadow-[0_12px_36px_rgba(224,122,95,0.55)] hover:-translate-y-0.5 transition-[box-shadow,transform]"
            >
              Unisciti alla lista d'attesa
              <ArrowRight size={18} />
            </button>
          </div>
          <p
            className="flex items-center gap-2 text-xs text-white/70 mt-5"
            data-testid="hero-microcopy"
          >
            <Check size={14} className="text-[#F2B39B]" />
            Beta privata gratuita. Nessuna carta di credito richiesta.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
